export const asideMacroscopic_zh ={
    Macroscopic:{
        monetaryFinance:"货币金融",
        loan:"贷款",
        bond:"债券",
        stockIndex:"股指",
        GDP:"GDP",
        info:"资讯",
    }
}
export const asideMacroscopic_en ={
    Macroscopic:{
        monetaryFinance:"Monetary Finance",
        loan:"loan",
        bond:"bond",
        stockIndex:"Stock index",
        GDP:"GDP",
        info:"information",
    }
}

